import _ from 'lodash'
import common from './common'

export default {
  setCartItems(state, payload) {
    state.cartItems = payload
  },

  addCartItem(state, payload) {
    Array.isArray( payload ) ? state.cartItems.unshift(...payload) : state.cartItems.unshift(payload)
  },

  deleteCartItems(state, payload) {
    state.cartItems = _.remove(state.cartItems, function(n) {
      return !_.find(payload, {id: n.id} )
    })
  },

  deleteAllCarts(state) {
    state.cartItems = []
  },

  createCartItem(state, payload) {
    state.cartItems.push(payload)
  },

  updateCartItem(state, payload) {
    let result = common._returnIndexById(state.cartItems, payload.id)
    if (result.success) {
      state.cartItems[result.returned]  = payload
    }
  },
}
